import * as Models from "../.";
export interface IEditCustomerProfile {
    customer: Models.Customer.Customer.Customer;
    account: Models.Customer.Account.Account;
    serviceAddress: Models.Customer.VerifiedAddress.VerifiedAddress;
    billingAddress: Models.Customer.Address.Address;
    system: Models.Customer.System.System;
    emails: Models.Customer.ContactMechanism.ContactMechanism[];
    phoneNumbers: Models.Customer.ContactMechanism.ContactMechanism[];
    active: boolean;
    hasOpportunity: boolean;
    customerType: string;
    permitApplicationsSubmissionDate: Date;
    manualBillingFeeCredit: number;
    hasBillingFee: boolean;
}

export class EditCustomerProfile implements IEditCustomerProfile {
    customer: Models.Customer.Customer.Customer;
    account: Models.Customer.Account.Account;
    serviceAddress: Models.Customer.VerifiedAddress.VerifiedAddress;
    billingAddress: Models.Customer.Address.Address;
    system: Models.Customer.System.System;
    emails: Models.Customer.ContactMechanism.ContactMechanism[];
    phoneNumbers: Models.Customer.ContactMechanism.ContactMechanism[];
    active: boolean;
    hasOpportunity: boolean;
    customerType: string;
    permitApplicationsSubmissionDate: Date;
    manualBillingFeeCredit: number;
    hasBillingFee: boolean;
}

export interface IAvailableAccountingInformationResponse {
    funds: IFund[];
    merchants: IMerchant[];
}

export interface IFund {
    code: string;
    name: string;
}

export interface IMerchant {
    code: string;
    name: string;
}